import React, { useEffect } from "react"

import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"

import { AvailableLookupConsumer } from "@common-shared/config/lookup.config"

import { useCptCodes } from "@front-shared/hooks/cptCodes.hook"
import { useScrollFix } from "@front-shared/hooks/scrollFix.hook"

import { embedCalculatorActionCreators } from "../../actions/embedCalculator.actions"
import { runtimeActionCreators } from "../../actions/runtime.actions"
import { embedCalculatorSelector } from "../../selectors/embedCalculator.selector"
import { CalculatorDataCollectionComponent } from "../calculator/calculatorDataCollection.component"

export const EmbedCalculatorComponent: React.FunctionComponent = () => {
    useScrollFix()

    const dispatch = useDispatch()

    const { embedKey } = useParams()

    const embedCalculatorState = useSelector(embedCalculatorSelector)

    const { availableCptCodesStyled } = useCptCodes(
        AvailableLookupConsumer.embedCalculator,
    )

    // Set in state so all parts knows that this is embed calculator
    useEffect(() => {
        dispatch(runtimeActionCreators.setIsEmbed(true))
    }, [])

    // Set in state our embed key
    useEffect(() => {
        if (!embedKey) {
            return
        }

        dispatch(embedCalculatorActionCreators.setEmbedKey(embedKey))
    }, [embedKey])

    // Wait until embed key is set in state
    return embedCalculatorState.embedKey && availableCptCodesStyled.length ? (
        <CalculatorDataCollectionComponent cptCodes={availableCptCodesStyled} />
    ) : null
}
